import type { FaireProductEntity } from "../../entity_types/product";

export const p_xzwgnz6z67: FaireProductEntity = {
  token: "p_xzwgnz6z67",
  type: "product",
  name: "Sterling Silver Moissanite Pave Round Men's Ring",
  brandToken: "b_75net88q84",
  brandName: "Atlanta Jewelers Supply",
  imageUrl: "https://cdn.faire.com/fastly/00e1019d5d6e55ca929e81b5de4f6917e6a90f5a5c30892947d504c9279e73af.jpeg",
  galleryImageUrls: [],
  priceDollars: 105.3,
  description: "",
  tags: [],
  msrpDollars: 210.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:59:50.867Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
